module.exports = __webpack_public_path__ + "img/carrier-logo.c500a380.png";